import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  FormInputSelect,
  Table,
  Popup,
  Alert
} from 'camino-react'
import _ from 'lodash'

import { cloudhelpPost } from 'Utilities/CloudHelp'

export default class MergeTicketsModalForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedPrimaryTicketId: null,
      selectedPrimaryTicketUrl: null,
      selectedPrimaryTicketTitle: '',
      mergeConfirmBtnText: 'Merge Tickets',
      statusMessage: {},
      submitButton: {
        disabled: false,
        text: 'Submit'
      }
    }
  }

  handleSelect = ({ ticketId, ticketMergePath, ticketTitle }) => {
    this.setState({
      selectedPrimaryTicketId: ticketId,
      selectedPrimaryTicketUrl: ticketMergePath,
      selectedPrimaryTicketTitle: ticketTitle
    })
  }

  submitTicketsToMerge = (ticketIdsToMerge, selectedPrimaryTicketId) => {
    const { selectedPrimaryTicketUrl } = this.state
    const postData = {
      primary_ticket_id: selectedPrimaryTicketId,
      secondary_ticket_ids: _.filter(
        ticketIdsToMerge, ticketIdToMerge => ticketIdToMerge !== selectedPrimaryTicketId
      )
    }

    this.setState({
      submitButton: {
        disabled: true,
        text: 'Merging Tickets...'
      },
      statusMessage: {}
    })

    cloudhelpPost(selectedPrimaryTicketUrl, postData)
      .then(({ data: { successMessage, redirectUrl } }) => {
        this.setState({
          submitButton: {
            disabled: true,
            text: 'Tickets merged',
            successful: true
          },
          statusMessage: {
            type: 'success',
            title: 'The tickets were merged successfully',
            text: [successMessage]
          }
        })

        setTimeout(
          () => (window.location.href = redirectUrl),
          1000
        )
      })
      .catch(({ response: { data: { errors } } }) => {
        this.setState({
          submitButton: {
            disabled: false,
            text: 'Submit'
          },
          statusMessage: {
            type: 'error',
            title: 'There were some errors while merging the tickets',
            text: errors
          }
        })
      })
  }

  render () {
    const { ticketsToMerge } = this.props
    const {
      selectedPrimaryTicketTitle,
      selectedPrimaryTicketUrl,
      selectedPrimaryTicketId,
      mergeConfirmBtnText,
      statusMessage,
      submitButton: {
        disabled: submitButtonDisabled,
        text: submitButtonText,
        successful: submitButtonSuccessful
      }
    } = this.state
    const { handleSelect, submitTicketsToMerge } = this
    const ticketIdsToMerge = _.map(ticketsToMerge, ticketToMerge => ticketToMerge.ticketId)

    const columns = [
      {
        text: 'ID',
        accessor: 'ticketId',
        type: 'number'
      },
      {
        text: 'Title',
        accessor: 'ticketTitle'
      },
      {
        text: 'Contact',
        accessor: 'ticketContact'
      }
    ]

    const ticketsToMergeOptions = _.map(ticketsToMerge, ticketToMerge => {
      const { ticketId, ticketTitle } = ticketToMerge

      return (
        {
          label: `#${ticketId}: ${ticketTitle}`,
          value: ticketToMerge
        }
      )
    })

    return (
      <div>
        <FormInputSelect
          value={_.find(ticketsToMergeOptions, { label: `#${selectedPrimaryTicketId}: ${selectedPrimaryTicketTitle}` })}
          options={ticketsToMergeOptions}
          placeholder="Select Primary Ticket"
          onValue={selectedPrimaryTicket => handleSelect(selectedPrimaryTicket)}
          searchable
        />
        <div className="detail-list">
          <div className="detail-list__info-box">
            <p className="detail-list__title" />
            <p>
              Choose which ticket others will be &nbsp;
              <strong>
                merged into
              </strong>
              &nbsp; from the list below.
            </p>
            <p style={{ marginBottom: '0' }}>
                All &nbsp;
              <strong>
                correspondence
              </strong>
                , &nbsp;
              <strong>
                timesheets
              </strong>
              &nbsp; and &nbsp;
              <strong>
                configurations
              </strong>
              &nbsp; will be merged into the &nbsp;
              <strong>
                main ticket
              </strong>
              .
              <strong>
                This action is unreversible!
              </strong>
            </p>
          </div>
        </div>
        <Table
          columns={columns}
          data={ticketsToMerge}
        />
        <Popup
          modal
          trigger={() => (
            <div className="flex flex--centered">
              <button
                type="button"
                disabled={selectedPrimaryTicketUrl === null}
                className="button"
                style={{ marginTop: '20px', textAlign: 'center' }}
              >
                {mergeConfirmBtnText}
              </button>
            </div>
          )
          }
        >
          {close => (
            <section className="modal__content">
              <header className="modal__content-header">
                <h3 className="modal__content-header-title modal__header-warning">
                  Warning!
                </h3>
              </header>
              {!_.isEmpty(statusMessage) && (
                <Alert type={statusMessage.type} title={statusMessage.title}>
                  {statusMessage.text}
                </Alert>
              )}
              <div className="card--padding-large" style={{ color: '#666' }}>
                Are you sure you want to merge &nbsp;
                <strong>
                  {`${ticketsToMerge.length - 1}`}
                </strong>
                &nbsp; tickets into &nbsp;
                <strong>
                  #
                  {`${selectedPrimaryTicketId}`}
                  :&nbsp;
                  {`${selectedPrimaryTicketTitle}`}
                </strong>
                ?
                <div className="flex flex--space-evenly" style={{ paddingTop: '20px' }}>
                  { submitButtonSuccessful ? (

                    <Button
                      onClick={() => close()}
                    >
                      Close Modal
                    </Button>
                  ) : (
                    <>
                      <Button
                        outline
                        color="secondary"
                        disabled={submitButtonDisabled}
                        onClick={() => close()}
                      >
                        Cancel
                      </Button>

                      <Button
                        disabled={submitButtonDisabled}
                        onClick={() => submitTicketsToMerge(ticketIdsToMerge, selectedPrimaryTicketId)}
                      >
                        {submitButtonText}
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </section>
          )}
        </Popup>

      </div>
    )
  }
}

MergeTicketsModalForm.propTypes = {
  ticketsToMerge: PropTypes.arrayOf(PropTypes.number).isRequired
}
